import { ROP } from '../types';
export default {
  type: ROP,
  service: 'infura.io-ws',
  url: 'wss://ropsten.infura.io/ws',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
